// gatsby-browser.js
import './src/styles/global/_reboot.scss';
import './src/styles/global/_base.scss';
import React from 'react';
import ContactFormContextWrapper from './src/components/contextWrapper/contactFormContextWrapper';

export const wrapRootElement = ({ element }) => {
  return <ContactFormContextWrapper>{element}</ContactFormContextWrapper>;
};
